<template>
  <div class="text-item-wrap">
    <div class="text-label-wrap">
      <span class="text-label">{{ label }}</span>
    </div>
    <div class="tag-wrap">
      <lego-chip-wrapper v-model="listTag" v-if="listTag.length" />
      <c-nodata v-else></c-nodata>
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from '../monTarget.mixin.js';

export default {
  name: 'TagBox',
  mixins: [i18nMixin, monTargetMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    tagItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isEllipsis: false,
      listTag: []
    };
  },
  watch: {
    tagItems: {
      deep: true,
      immediate: true,
      handler(value) {
        this.listTag = value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-item-wrap {
  .text-label-wrap {
    .text-label {
      display: inline-block;
      color: #2e3138;
      font-weight: 400;
    }
  }

  .tag-wrap {
    padding-top: 8px;
    :deep(.lego-chip-wrapper__container) {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      .lego-chip-wrapper__item {
        margin-right: 0px !important;
        margin-bottom: 0px !important;
        max-width: 100% !important;
        background-color: #eef2fc !important;
        height: 24px !important;
      }
    }
  }
}
</style>
